"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MecoWorkerWrapper = void 0;
const nexus_1 = require("../main/nexus");
class MecoWorkerWrapper {
    constructor(callback) {
        this.requests = new Map(); // could be a map
        this.count = 0;
        const wrapper = this;
        // The meshcoder url must be defined through Nexus.meshcoder
        this.worker = new Worker(nexus_1.Nexus.meshcoder);
        this.worker.onmessage = function (event) {
            const requestData = wrapper.requests.get(event.data.request);
            if (!requestData) {
                throw 'Could not match decoded result to given request ' + event.data.request;
            }
            callback(requestData.context, requestData.model, requestData.node, event.data.buffer);
        };
    }
    postRequest(context, model, node, patches, buffer) {
        const signature = {
            texcoords: model.vertex.texCoord ? 1 : 0,
            colors: model.vertex.color ? 1 : 0,
            normals: model.vertex.normal ? 1 : 0,
            indices: model.face.index ? 1 : 0
        };
        const messageNode = {
            id: node.id,
            faces: node.faces,
            vertices: node.vertices,
            buffer: buffer,
            request: this.count
        };
        const message = {
            signature: signature,
            node: messageNode,
            patches: patches
        };
        this.worker.postMessage(message);
        this.requests.set(this.count++, { context: context, model: model, node: node });
    }
}
exports.MecoWorkerWrapper = MecoWorkerWrapper;
